/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import { AddCircle, TextFields } from "@mui/icons-material";
import AddIcon from "@material-ui/icons/Add";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import CampaignModalPhrase from "../../components/CampaignModalPhrase";
import { Can } from "../../components/Can";

const CampaignsPhrase = () => {
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);

  const [campaignflows, setCampaignFlows] = useState([]);
  const [ModalOpenPhrase, setModalOpenPhrase] = useState(false);
  const [campaignflowSelected, setCampaignFlowSelected] = useState();

  const [whatsApps, setWhatsApps] = useState([]);

  const handleDeleteCampaign = async (campaignId) => {
    try {
      await api.delete(`/flowcampaign/${campaignId}`);
      toast.success("Campanha deletada com sucesso");
      getCampaigns();
    } catch (err) {
      toastError(err);
    }
    setConfirmModalOpen(false);
    setDeletingContact(null);
  };

  const getWhatsApps = async () => {
    try {
      const response = await api.get("/whatsapp");
      setWhatsApps(response.data || []);
    } catch (error) {
      console.error('Erro ao buscar WhatsApps:', error);
    }
  };

  const getCampaigns = async () => {
    try {
      setLoading(true);
      const response = await api.get("/flowcampaign");
      
      let flowData = [];
      
      if (response.data) {
        if (Array.isArray(response.data.flow)) {
          flowData = response.data.flow;
        }
        else if (response.data.data && Array.isArray(response.data.data.flow)) {
          flowData = response.data.data.flow;
        }
        else if (Array.isArray(response.data.data)) {
          flowData = response.data.data;
        }
        else if (Array.isArray(response.data)) {
          flowData = response.data;
        }
        else {
          const dataKeys = Object.keys(response.data);
          for (const key of dataKeys) {
            if (Array.isArray(response.data[key])) {
              flowData = response.data[key];
              break;
            }
          }
        }
      }
      
      setCampaignFlows(flowData);
      
    } catch (error) {
      console.error('Erro ao buscar campanhas:', error);
      toastError(error);
      setCampaignFlows([]);
    } finally {
      setLoading(false);
    }
  };

  const onSaveModal = () => {
    getCampaigns();
  };

  const renderWhatsAppConnections = (whatsappIds) => {
    if (!whatsappIds || !Array.isArray(whatsappIds) || whatsappIds.length === 0) {
      return <span style={{ fontSize: "12px", color: "#6b7280" }}>Nenhuma conexão</span>;
    }

    if (whatsappIds.length > 3) {
      const firstTwo = whatsappIds.slice(0, 2);
      const remaining = whatsappIds.length - 2;

      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center", justifyContent: "center" }}>
          {firstTwo.map((whatsappId) => {
            const whatsapp = whatsApps.find(w => w.id === whatsappId);
            return (
              <span
                key={whatsappId}
                style={{
                  display: "inline-block",
                  padding: "2px 8px",
                  borderRadius: "12px",
                  fontSize: "11px",
                  fontWeight: 600,
                  border: "1px solid #d1d5db",
                  background: whatsapp?.status === "CONNECTED" ? "#d1fae5" : "#f3f4f6",
                  color: whatsapp?.status === "CONNECTED" ? "#059669" : "#6b7280",
                }}
                title={whatsapp ? `${whatsapp.name} (${whatsapp.status})` : `ID: ${whatsappId}`}
              >
                {whatsapp ? whatsapp.name : `ID: ${whatsappId}`}
              </span>
            );
          })}
          <span
            style={{
              display: "inline-block",
              padding: "2px 8px",
              borderRadius: "12px",
              fontSize: "11px",
              fontWeight: 600,
              border: "1px solid #3b82f6",
              background: "#dbeafe",
              color: "#1e40af",
            }}
            title={`Mais ${remaining} conexão(ões)`}
          >
            +{remaining}
          </span>
        </div>
      );
    }

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center", justifyContent: "center" }}>
        {whatsappIds.map((whatsappId) => {
          const whatsapp = whatsApps.find(w => w.id === whatsappId);
          return (
            <span
              key={whatsappId}
              style={{
                display: "inline-block",
                padding: "2px 8px",
                borderRadius: "12px",
                fontSize: "11px",
                fontWeight: 600,
                border: "1px solid #d1d5db",
                background: whatsapp?.status === "CONNECTED" ? "#d1fae5" : "#f3f4f6",
                color: whatsapp?.status === "CONNECTED" ? "#059669" : "#6b7280",
              }}
              title={whatsapp ? `${whatsapp.name} (${whatsapp.status})` : `ID: ${whatsappId}`}
            >
              {whatsapp ? whatsapp.name : `ID: ${whatsappId}`}
            </span>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    getCampaigns();
    getWhatsApps();
  }, []);

  return (
    <div style={{ padding: "24px", background: "#f5f7fa", minHeight: "100vh" }}>
      <ConfirmationModal
        title={
          deletingContact &&
          `${i18n.t("campaigns.confirmationModal.deleteTitle")} ${deletingContact.name}?`
        }
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteCampaign(deletingContact.id)}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>

      <CampaignModalPhrase
        open={ModalOpenPhrase}
        onClose={() => setModalOpenPhrase(false)}
        FlowCampaignId={campaignflowSelected}
        onSave={onSaveModal}
      />

      {/* Header */}
      <div style={{ marginBottom: "24px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: 700, color: "#1a1a1a", margin: 0 }}>
          🔄 Campanhas de Fluxo
        </h1>
        <button
          onClick={() => {
            setCampaignFlowSelected(undefined);
            setModalOpenPhrase(true);
          }}
          style={{
            padding: "10px",
            background: "var(--primaryColor, #065183)",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onMouseEnter={(e) => {
            e.target.style.opacity = "0.9";
            e.target.style.transform = "translateY(-1px)";
            e.target.style.boxShadow = "0 2px 8px rgba(6, 81, 131, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.target.style.opacity = "1";
            e.target.style.transform = "none";
            e.target.style.boxShadow = "none";
          }}
          title="Nova Campanha"
        >
          <AddIcon style={{ fontSize: "20px" }} />
        </button>
      </div>

      {/* Table */}
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          border: "1px solid #e8ecf1",
          overflow: "hidden",
          height: "calc(100vh - 220px)",
          overflowY: "auto",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f9fafb", borderBottom: "2px solid #e8ecf1", position: "sticky", top: 0, zIndex: 10 }}>
            <tr>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "12px", fontWeight: 600, color: "#666" }}>
                Nome
              </th>
              <th style={{ padding: "12px 16px", textAlign: "center", fontSize: "12px", fontWeight: 600, color: "#666", width: "300px" }}>
                Conexões
              </th>
              <th style={{ padding: "12px 16px", textAlign: "center", fontSize: "12px", fontWeight: 600, color: "#666", width: "120px" }}>
                Status
              </th>
              <th style={{ padding: "12px 16px", textAlign: "center", fontSize: "12px", fontWeight: 600, color: "#666", width: "120px" }}>
                {i18n.t("contacts.table.actions")}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" style={{ padding: "40px", textAlign: "center", color: "#999" }}>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "3px solid #e8ecf1",
                        borderTop: "3px solid #3b82f6",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    Carregando...
                  </div>
                </td>
              </tr>
            ) : campaignflows && Array.isArray(campaignflows) && campaignflows.length > 0 ? (
              campaignflows.map((flow) => (
                <tr
                  key={flow.id}
                  style={{
                    borderBottom: "1px solid #e8ecf1",
                    transition: "background 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a1a1a" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <TextFields style={{ color: "#6b7280", fontSize: "18px" }} />
                      <div>
                        <div style={{ fontWeight: 500 }}>{flow.name || 'Nome não definido'}</div>
                        {flow.phrase && Array.isArray(flow.phrase) && (
                          <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>
                            {flow.phrase.length} frase(s) configurada(s)
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a1a1a", textAlign: "center" }}>
                    {renderWhatsAppConnections(flow.whatsappIds)}
                  </td>
                  <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a1a1a", textAlign: "center" }}>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "11px",
                        fontWeight: 600,
                        background: flow.status ? "#d1fae5" : "#f3f4f6",
                        color: flow.status ? "#059669" : "#6b7280",
                        border: flow.status ? "1px solid #059669" : "1px solid #d1d5db",
                      }}
                    >
                      {flow.status ? "Ativo" : "Desativado"}
                    </span>
                  </td>
                  <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a1a1a", textAlign: "center" }}>
                    <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
                      <button
                        onClick={() => {
                          setCampaignFlowSelected(flow.id);
                          setModalOpenPhrase(true);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          padding: "6px",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "4px",
                          transition: "background 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = "#f0f0f0";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = "none";
                        }}
                        title="Editar campanha"
                      >
                        <EditIcon style={{ color: "#6b7280", fontSize: "18px" }} />
                      </button>

                      <Can
                        role={user.profile}
                        perform="contacts-page:deleteContact"
                        yes={() => (
                          <button
                            onClick={() => {
                              setConfirmModalOpen(true);
                              setDeletingContact(flow);
                            }}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "4px",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = "#fee2e2";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = "none";
                            }}
                            title="Excluir campanha"
                          >
                            <DeleteOutlineIcon style={{ color: "#ef4444", fontSize: "18px" }} />
                          </button>
                        )}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ padding: "40px", textAlign: "center", color: "#999" }}>
                  <div>Nenhuma campanha encontrada</div>
                  <div style={{ fontSize: "12px", marginTop: "8px", color: "#6b7280" }}>
                    Clique em "Nova Campanha" para criar sua primeira campanha de fluxo
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default CampaignsPhrase;
